import React, { useContext, useEffect, useState } from 'react'
import { Box, Heading } from '@chakra-ui/react'
import { IoMdSwitch } from 'react-icons/io'
import { AiFillStar, AiFillClockCircle } from 'react-icons/ai'
import { BiDollar } from 'react-icons/bi'
import ModalFilters from '../ModalFilters'
import { MainContext } from '../../context'
import BadgeFilter from './BadgeFilter'
import { filterPromotionDataLayer } from '../../utils/gtmDatalayer'

const Tabs = ({ accentColor, dictionary, lang, fontFamily, env, skin }) => {
  const {
    width,
    setFilters,
    filters,
    setCurrentTab,
    currentTab,
    isError,
    isLoading
  } = useContext(MainContext)

  const renderFilterText = () => {
    switch (skin) {
      case 'COPPEL':
        return dictionary.TABS.bancoppel_emoney
      case 'INVEX':
        return dictionary.TABS.bonification
      case 'SUBURBIA':
        return dictionary.TABS.suburbia_refund
      default:
        return dictionary.TABS.cashback
    }
  }

  const tabs = [
    { id: 0, title: dictionary.TABS.rating, param: 'DESC' },
    {
      id: 1,
      title: renderFilterText(),
      param: 'DESC'
    },
    {
      id: 2,
      title:
        env !== 'legacy' ? dictionary.TABS.recent : dictionary.TABS.popularity,
      param: 'DESC'
    },
    { id: 3, title: undefined, param: undefined }
  ]

  const [isOpen, setModal] = useState(false)

  useEffect(() => {
    if (currentTab?.id === 0) {
      setFilters({
        ...filters,
        price: undefined,
        popularity: undefined,
        rating: currentTab?.param
      })
    } else if (currentTab?.id === 1) {
      setFilters({
        ...filters,
        popularity: undefined,
        rating: undefined,
        price: currentTab?.param
      })
    } else if (currentTab?.id === 2) {
      setFilters({
        ...filters,
        price: undefined,
        rating: undefined,
        popularity: currentTab?.param
      })
    }
  }, [currentTab])

  useEffect(() => {
    if (isError) {
      setFilters({
        ...filters,
        category: [],
        priceLevel: undefined,
        businessType: undefined,
        offerType: undefined,
        fetchData: false
      })
    }
  }, [isError])

  const handleAllCleaning = () => {
    setFilters({
      ...filters,
      name: undefined,
      category: [],
      offerType: undefined,
      priceLevel: undefined,
      businessType: undefined,
      fetchData: true
    })
  }

  const handleActiveTab = (item, i) => {
    setCurrentTab(item)
    handleAllCleaning()
    if (currentTab?.id === i) {
      setCurrentTab()
      setFilters({
        ...filters,
        popularity: undefined,
        rating: undefined,
        price: undefined,
        fetchData: true
      })
    }
  }

  const renderIcon = (key) => {
    if (key === 0) {
      return (
        <AiFillStar
          color={
            currentTab?.id === key ? 'white' : 
            skin === 'FINSUS' ? '#FF5F54' : '#636363'
          }
          fontSize='1.18rem'
        />
      )
    } else if (key === 1) {
      return (
        <BiDollar
          color={
            currentTab?.id === key ? 'white' : 
            skin === 'FINSUS' ? '#FF5F54' : '#636363'

          }
          fontSize='1.18rem'
        />
      )
    } else if (key === 2) {
      return (
        <AiFillClockCircle
          color={
            currentTab?.id === key ? 'white' : 
            skin === 'FINSUS' ? '#FF5F54' : '#636363'
          }
          fontSize='1.18rem'
        />
      )
    } else {
      return (
        <IoMdSwitch
          color={
            skin === 'CLARA'
              ? '#636363'
              : skin === 'COPPEL'
              ? '#495057'
              : skin === 'INVEX'
              ? '#636363'
              : skin === 'UNIQ'
              ? '#636363'
              : skin === 'FINSUS'
              ? 'white'
              : skin === 'LIVERPOOL'
              ? '#555555'
              : skin === 'SUBURBIA'
              ? '#636363'
              : accentColor
          }
          fontSize='1.65rem'
        />
      )
    }
  }

  return (
    <Box>
      <Box
        pt={skin === 'CLARA' ? '0rem' : ['2rem', '2rem', '3rem', '3rem']}
        w='100%'
        h='auto'
        display='flex'
        alignItems='center'
        justifyContent='center'
        flexDirection='column'
      >
        {skin === 'CLARA' ? (
          <Heading
            color='brand.secondaryDark'
            fontSize={['xl', '2xl', '3xl', '3xl']}
            fontFamily={fontFamily}
            fontWeight='600'
            pt='2rem'
            pb='2rem'
          >
            {dictionary.CARDS.title}
          </Heading>
        ) : null}
        <Box
          w='100%'
          display='flex'
          alignItems='center'
          justifyContent='center'
          flexFlow='wrap'
        >
          {tabs.map((item, i) => {
            return (
              <Box
                w={i === 3 ? '50px' : 'auto'}
                key={i}
                shadow={skin !== 'COPPEL' && 'xs'}
                onClick={() => {
                  i === 3 ? setModal(true) : handleActiveTab(item, i)
                  filterPromotionDataLayer(item.title, skin)
                }}
                bg={
                  currentTab?.id === i
                    ? accentColor
                    : i === 3
                    ? skin === 'CLARA'
                      ? 'transparent'
                      : skin === 'COPPEL'
                      ? 'brand.white'
                      : skin === 'INVEX'
                      ? 'transparent'
                      : skin === 'FINSUS'
                      ? '#FF5F54'
                      : '#FFFFFF'

                    : skin === 'COPPEL'
                    ? 'white'
                    : skin === 'INVEX'
                    ? 'transparent'
                    : skin === 'UNIQ'
                    ? 'transparent'
                    : skin === 'FINSUS'
                    ? 'transparente'
                    : skin === 'LIVERPOOL'
                    ? 'transparent'
                    : skin === 'SUBURBIA'
                    ? 'transparent'
                    : '#FFFF'
                    
                }
                _hover={{
                  bg:
                    i === 3
                      ? skin === 'CLARA' ||
                        skin === 'COPPEL' ||
                        skin === 'INVEX' ||
                        skin === 'UNIQ' ||
                        skin === 'FINSUS'||
                        skin === 'LIVERPOOL' ||
                        skin === 'SUBURBIA'
                        ? null
                        : '#81A0FF'
                      : null
                }}
                borderLeftRadius={
                  i === 0 ? (skin === 'COPPEL' ? '2px' : skin === 'FINSUS' ? '4px' : '6px') : '0px'
                }
                borderRightRadius={
                  i === 3 ? (skin === 'COPPEL' ? '2px' : skin === 'FINSUS' ? '4px' : '6px') : '0px'
                }
                border='1px solid'
                borderColor='brand.tabBorder'
                borderRightWidth={i === 3 ? '1px' : '0px'}
                p={i === 3 ? '.4rem 0rem' : '.62rem 1rem'}
                cursor='pointer'
                display='flex'
                alignItems='center'
                justifyContent='center'
                flexDirection='row'
              >
                {renderIcon(i)}
                {i < 3 && width >= 657 ? (
                  <Heading
                    m='0px'
                    pl='.5rem'
                    fontSize='md'
                    color={currentTab?.id === i ? 'white' : 'brand.tabText'}
                    fontFamily={fontFamily}
                    fontWeight='500'
                  >
                    {item.title}
                  </Heading>
                ) : null}
              </Box>
            )
          })}
        </Box>
      </Box>
      <Box
        w='100%'
        display='flex'
        alignItems='center'
        justifyContent='center'
        flexDirection='row'
        flexFlow='wrap'
        mt='15px'
      >
        {filters.category === undefined ||
        isError === true ||
        isLoading === true
          ? null
          : filters.category.map((item, i) => {
            const dynamicAccentColor = skin === "FINSUS" ? "#23223F" : accentColor;
              return (
                <BadgeFilter
                  key={i}
                  accentColor={dynamicAccentColor}
                  handleFilter={(item) =>
                    setFilters({
                      ...filters,
                      category: filters.category.filter((cat) => cat !== item)
                    })
                  }
                  currentFilter={item}
                  lang={lang}
                  type='category'
                  dictionary={dictionary}
                  skin={skin}
                />
              )
            })}
        {filters.offerType === undefined ||
        filters.offerType.length === 0 ||
        isError === true ||
        isLoading === true ? null : (
          <BadgeFilter
            accentColor={skin === 'FINSUS' ? '#23223F' : accentColor}
            handleFilter={() =>
              setFilters({ ...filters, offerType: undefined })
            }
            currentFilter={{ label: filters.offerType }}
            lang={lang}
            type='offerType'
            dictionary={dictionary}
            skin={skin}
          />
        )}
        
        {filters.priceLevel === undefined ||
        filters.priceLevel.length === 0 ||
        isError === true ||
        isLoading === true ? null : (
          <BadgeFilter
            accentColor={skin === 'FINSUS' ? '#23223F' : accentColor}
            handleFilter={() =>
              setFilters({ ...filters, priceLevel: undefined })
            }
            currentFilter={{ label: filters.priceLevel }}
            lang={lang}
            type='priceLevel'
            dictionary={dictionary}
            skin={skin}
          />
        )}

        {filters.businessType === undefined ||
        isError === true ||
        isLoading === true ? null : (
          <BadgeFilter
            accentColor={skin === 'FINSUS' ? '#23223F' : accentColor}
            handleFilter={() =>
              setFilters({ ...filters, businessType: undefined })
            }
            currentFilter={{ label: filters.businessType }}
            lang={lang}
            type='businessType'
            dictionary={dictionary}
            skin={skin}
          />
        )}
      </Box>
      <Box
        w='100%'
        display='flex'
        alignItems='center'
        justifyContent='center'
        flexDirection='row'
        mt='10px'
      >
        {filters.businessType !== undefined ||
        filters.category?.length > 0 ||
        filters.offerType !== undefined ||
        filters.priceLevel !== undefined ? (
          <BadgeFilter
            accentColor={skin === 'FINSUS' ? '#23223F' : accentColor}
            handleFilter={() => handleAllCleaning()}
            currentFilter={{ label: 'Borrar filtros' }}
            type='clean'
            lang={lang}
            skin={skin}
          />
        ) : null}
      </Box>
      <ModalFilters
        accentColor={skin === 'FINSUS' ? '#23223F' : accentColor}
        skin={skin}
        isOpen={isOpen}
        handleModal={() => setModal(false)}
        dictionary={dictionary}
        lang={lang}
        fontFamily={fontFamily}
        env={env}
        handleFilters={(category, offerType, priceLevel, businessType) => {
          setFilters({
            ...filters,
            category,
            offerType,
            priceLevel,
            businessType
          })
        }}
      />
    </Box>
  )
}

export default Tabs
